import { render, staticRenderFns } from "./CategoryOverview.vue?vue&type=template&id=00823c3c"
import script from "./CategoryOverview.vue?vue&type=script&lang=js"
export * from "./CategoryOverview.vue?vue&type=script&lang=js"
import style0 from "./CategoryOverview.vue?vue&type=style&index=0&id=00823c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports